<div class="page-wrapper">
    <mat-card class="centered-card">
        <mat-toolbar class="justify-content-center" color="primary">Donate - Help us grow</mat-toolbar>
        <form [formGroup]="donateForm" class="p-3">
            <div>
                <mat-form-field class="m-1 w-100">
                    <mat-label>Amount(US$)</mat-label>
                    <input matInput required name="amount" formControlName="amount" appTwoDigitDecimaNumber>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="m-1 w-100">
                    <mat-label>Name</mat-label>
                    <input matInput name="donarName" formControlName="donarName">
                </mat-form-field>
            </div>

            <div class="d-flex justify-content-center">
                <button class="m-2" mat-raised-button type="submit" (click)="onSubmit()" color="primary"
                    [disabled]="!donateForm.valid">Donate</button>
                <button class="m-2" mat-raised-button type="button" color="primary" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </mat-card>
</div>

<!-- <p>Donation Amount: {{ paymentData.amount }}</p>
<p>Form Value: {{ donateForm.value | json }}</p>

<p>Form Status: {{ donateForm.status }}</p> -->